module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/beata-pyszkowska-bafcbc4983d44bb6ca1805bf4de76c95.png";